import type { BlockSequencing } from 'shared-types';

type LocaleData = BlockSequencing['locales'][string];

const timestamp = Date.now().toString();

const defaultOptions = [{ id: timestamp + '1' }, { id: timestamp + '2' }].map(
  (option) => ({
    id: option.id,
    text: `{{ locales.translatable.option_${option.id}_text }}` as const
  })
);

const defaultBlockData = {
  isMandatory: false,
  options: defaultOptions,
  optionIds: defaultOptions.map((option) => option.id),
  pointsWeight: 2,
  requireAnswerToProceed: false,
  useRandomOrder: true
};

const translatable: LocaleData['translatable'] = {
  feedbackCorrect: '',
  feedbackIncorrect: '',
  feedbackPartiallyCorrect: '',
  question: '',
  ...defaultOptions.reduce((acc, option) => {
    acc[`option_${option.id}_text`] = '';
    return acc;
  }, {} as Record<`option_${string}_text`, string>)
};
const defaultLocaleData: LocaleData = { translatable };

const localePlaceholders = {
  feedbackCorrect: '{{ locales.translatable.feedbackCorrect }}' as const,
  feedbackIncorrect: '{{ locales.translatable.feedbackIncorrect }}' as const,
  feedbackPartiallyCorrect:
    '{{ locales.translatable.feedbackPartiallyCorrect }}' as const,
  options: defaultOptions,
  question: '{{ locales.translatable.question }}' as const
};

export const defaults = {
  defaultBlockData,
  defaultLocaleData,
  localePlaceholders
};

export const blockSequencingData: BlockSequencing = {
  ...defaultBlockData,
  ...localePlaceholders,
  locales: new Proxy({} as BlockSequencing['locales'], {
    get: (locales, languageVersion: string) => {
      return (locales[languageVersion] = defaultLocaleData);
    }
  })
};
